// extracted by mini-css-extract-plugin
export default {"loader":"LoaderCircle_loader__pEaSB"};